<template>
  <div class="father">
    <div class="shopinfo-header">
      <div class="shopinfo-header-body">
        <div v-for="(item, index) in info" :key="index" class="header-body-item">
          <div v-for="(it, inx) in item.ch" :key="inx" class="item" :style="it.style">
            <div class="label">{{ it.label }}：</div>
            <div class="value">{{ it.value }}</div>
          </div>
          <div></div>
        </div>
      </div>
    </div>
    <div class="shopinfo-header" style="height:auto; padding: 20px;">
      <el-form :inline="true" class="demo-form-inline" label-width="180px"
        style="background-color: #fff; padding:0 20px 0 20px;width: 100%" ref="dataFormRef" :model="service"
        label-position="right">
        <el-form-item v-for="(item, index) in formList" :key="index" :label="item.label" :prop="item.value">
          <el-input clearable :disabled="item.disabled" @change="changeLit.push(item.value)"
            :show-password="item.value === 'pass_word' || item.value === 'old_password'" v-model="service[item.value]"
            :placeholder="`请输入${item.label}`">
          </el-input>
        </el-form-item>
      </el-form>
      <div label="" class="wty-footer">
        <!-- <el-button type="success" @click="setMerchantId">配置微信店铺ID</el-button> -->
        <el-button type="danger" @click="psReset">密码重置</el-button>
        <el-button type="primary" @click="saveModify">保存修改</el-button>
      </div>

      <!-- <el-dialog title="重置密码" :visible.sync="dialogVisible" width="30%" top="10vh">
        <el-form label-width="120px">
          <el-form-item v-if="dialog_key == 'ps'" label="新密码：">
            <el-input v-model="pass_word" placeholder="" show-password></el-input>
          </el-form-item>
          <el-form-item v-if="dialog_key == 'wxmchid'" label="微信店铺id：">
            <el-input v-model="wxpay_info.wx_mch_no" placeholder=""></el-input>
          </el-form-item>
          <el-form-item v-if="dialog_key == 'wxmchid'" label="备注：">
            <el-input v-model="wxpay_info.remark" placeholder=""></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button v-if="dialog_key == 'ps'" type="primary" @click="changePs">确 定</el-button>
          <el-button v-if="dialog_key == 'wxmchid'" type="primary" @click="changeMchId">确 定</el-button>
        </span>
      </el-dialog> -->
    </div>
  </div>
</template>
<script>
/* eslint-disable no-unused-vars */
import {
  serviceProviderQuery,
  serviceProviderModify,
  serviceChangePs,
  //eslint-disable-next-line
  serviceWxPayquery
} from "@/api/service.js";
import { showDialog } from "@/js/public.js";
import { serviceSetMerchantId } from "@/api/v2/service.js";
//import { aesDecrypt } from "@/js/Aes";

export default {
  name: "wtyShopinfo",
  props: ["who"],
  data() {
    return {
      info: [],
      dialog_key: "",
      dialogVisible: false,
      service: {
        // pass_word: "",
        service_name: "",
        address: "",
        contacts: "",
        mobile_no: "",
        old_password: "",
        pass_word: ""
      },
      pass_word: "", //新密码
      wxpay_info: {
        wx_mch_no: "", //微信店铺id
        remark: "" //备注
      },
      rules: this.getRules(),
      wtycolumnList: [],
      formList: [],
      changeLit: []//用来保存修改过的字段
    };
  },
  async mounted() {
    this.getServiceInfo();
    // const res = await serviceWxPayquery();
  },
  methods: {
    //TODO: 查询接口还没好
    getmerchanId() { },
    setMerchantId() {
      this.dialogVisible = true;
      this.dialog_key = "wxmchid";
    },
    async changeMchId() {
      const res = await serviceSetMerchantId(this.wxpay_info);
      //console.log("绑定微信店铺：", res);
      if (this.testR(res)) {
        this.successMessage("绑定成功！");
      }
    },
    /* //TODO: 修改密码后需不需要重新登录
    async changePs() {
    }, */
    /**
     * 密码重置
     */
    async psReset() {
      if (await showDialog("重置密码", `确定重置${this.who === 'service' ? '服务商' : ''}密码吗？`) === true) {
        const ps = await this.$encrypt(this.pass_word, "pass_word");
        serviceChangePs(ps).then(res => {
          if (res.state === true) {
            this.successMessage(res.message);
            showDialog("重置密码", `密码已重置，新密码为：${res.pass_word} 请保存好新密码！`);
            localStorage.setItem("pass_word", res.pass_word);
          }
        });
      }
    },
    /**
     * 保存修改
     */
    async saveModify() {
      //console.log("修改的字段：", this.changeLit);
      if (this.changeLit.length === 0) {
        this.warnMessage("您还没有修改任何信息");
        return;
      }
      let list = [...new Set(this.changeLit)]; //去重
      console.log("修改的字段：", list);
      if ((list.indexOf('old_password') !== -1 && list.indexOf("pass_word") === -1) || (list.indexOf('pass_word') !== -1 && list.indexOf("old_password") === -1)) {
        this.warnMessage("修改密码时，请同时填写新密码");
        return;
      }
      let data = {};
      list.forEach(item => {
        data[item] = this.service[item];
      });

      /* console.log("修改的数据：", data);
      let data = { ...this.service }; */
      //data.mobile_no = await this.$encrypt(data.mobile_no, "mobile_no");
      // delete data.mobile_no;
      //console.log("修改数据：", data);

      //服务商
      const res = await serviceProviderModify(data);

      //console.log(res);
      if (res.state === true) {
        this.successMessage(res.message);
        //获取信息
        this.getServiceInfo();
      }
      if (list.indexOf('old_password') !== -1 && list.indexOf("pass_word") !== -1) {
        //修改密码后，清除本地密码缓存
        localStorage.setItem("pass_word", this.service.pass_word);
      }
    },
    /**
     * 获取表单规则
     */
    getRules() {
      let list = [
        // { label: "营业执照：", value: "business_license", type: "false" },
        { label: "服务商号：", value: "service_no", type: "false", disabled: true },
        { label: "服务商名称：", value: "service_name", type: "false", disabled: false },
        { label: "旧密码：", value: "old_password", type: "false", disabled: false },
        { label: "新密码：", value: "pass_word", type: "false", disabled: false },
        { label: "联系人：", value: "contacts", type: "false", disabled: false },
        { label: "手机号码：", value: "mobile_no", type: "false", disabled: false },
        { label: "地址：", value: "address", type: "true", disabled: false }
        // { label: "银行账户：", value: "bank_account_no", type: "true" },
        // { label: "账户名：", value: "bank_account_name", type: "true" },
        // { label: "银行全名：", value: "bank_full_name", type: "true" }
      ];

      var rules = {};
      this.$nextTick(() => {
        this.formList = list;
      });
      return rules;
    },
    /**
     * 获取服务商信息
     */
    async getServiceInfo() {
      /* 服务商 */
      const data = await serviceProviderQuery();
      //console.log(data);
      /* if (this.testR(res)) { */
      //let data = res.data.resp_data;
      this.info = [];
      this.service = { ...data };
      /* this.service.mobile_no = aesDecrypt(
        data.mobile_no,
        localStorage.getItem("access_token")
      ); */
      this.info[0] = {
        ch: [
          {
            label: "服务商号",
            value: data.service_no,
            style: "'width:30%'"
          },
          {
            label: "服务商名称",
            value: data.service_name,
            style: "'width:40%'"
          },
          {
            label: "联系人",
            value: data.contacts,
            style: "'width:30%'"
          }/* aesDecrypt(
              data.mobile_no,
              localStorage.getItem("access_token")
            ) */
        ]
      };
      this.info[1] = {
        ch: [
          {
            label: "地址",
            value: data.address,
            style: "'width:50%'"
          },
          {
            label: "联系电话",
            value: data.mobile_no,
            style: "'width:30%'",
            icon: "phone"
          }
        ]
      };
      /* if (localStorage.getItem("token_type") === "service" && localStorage.getItem("pass_word")) {
        this.service.old_password = localStorage.getItem("pass_word");
      } */
    }
  }
};
</script>

<style lang="less" scoped>
.father {
  display: flex;
  flex-direction: column;

}

.shopinfo-header {
  width: 98%;
  height: 150px;
  margin: 10px 1%;
  border: 1px solid #dcdfe6;
  padding: 5px;
  border-radius: 20px;

  // background-color: #dcdfe6;
  .shopinfo-header-body {
    width: 100%;
    height: 100%;
    border: 1px solid #dcdfe6;
    background-color: #fff;
    font-size: 18px;
    padding: 20px;

    .header-body-item {
      width: 100%;
      height: 50px;
      // background-color: rgb(240, 119, 119);
      display: flex;
      // justify-content: left;
      justify-content: space-between;
      align-items: center;

      .item {
        display: flex;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;

        .label {
          width: 100px;
          height: 100%;
          color: #606266;
          font-size: 16px;
        }

        .value {
          font-weight: 700;
        }
      }
    }
  }

  /deep/.el-input {
    width: 300px;
  }

  /deep/.el-dialog__footer {
    padding: 10px 20px 20px 20px !important;
  }
}
</style>
